import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
    import("@lexus.com/ui/dist/_nextgen/components/DynamicContentScroll")
);

const ComponentEditConfig = {
    emptyLabel: "Dynamic Content - Scroll",
    isEmpty: function (props) {
        return !props || !props.other || props.other.trim().length < 1;
    },
};

const transformData = (props) => {
    const transformed = { ...props || {} };
    return transformed;
};

const DynamicContentScroll = (props) => {
    const data = transformData(props);

    const { editorMode = false } = window;
    if (!editorMode) {
        return <Component {...data} />;
    }
};

export default withAemIntegration("lexus/components/content/dynamic-content/dynamic-content-scroll")(
    DynamicContentScroll,
    ComponentEditConfig
);
